<template>
	<v-container>
		<v-app-bar app color="purple">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline" v-if="parlamentar">Editar </span>
				<span class="d-none d-sm-inline" v-else>Novo </span>
				Parlamentar
			</v-toolbar-title>
		</v-app-bar>
		<v-card tile>
			<v-container>
				<v-parlamentar-form
					v-model="parlamentar"
					@salvando="v => (salvarLoading = v)"
					@removendo="v => (removerLoading = v)"
					@changeValid="v => (validForm = v)"
					ref="parlamentarForm"
				></v-parlamentar-form>
				<v-row>
					<v-col class="text-right" justify-end width="100%">
						<v-chip v-if="!validForm" class="ma-2" color="error" label outlined>
							Existem campos não validados. Favor verificar!
						</v-chip>
						<v-btn text class="mr-5" @click="cancelar">Cancelar</v-btn>
						<v-dialog v-model="dialog" persistent max-width="350">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mr-5"
									color="error"
									:loading="removerLoading"
									:disabled="removerLoading"
									v-bind="attrs"
									v-on="on"
								>
									Remover
								</v-btn>
							</template>
							<v-card>
								<v-card-title class="headline">
									Voce tem certeza disso?
								</v-card-title>
								<v-card-text v-if="parlamentar">
									<p>
										Você confirma a exclusão do parlamentar
										{{ parlamentar.nome }}
									</p>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn text @click="cancelarRemocao">
										Cancelar
									</v-btn>
									<v-btn color="error" text @click="confirmarRemocao">
										Confirmar
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
						<v-btn
							color="primary"
							:loading="salvarLoading"
							:disabled="salvarLoading || !validForm"
							@click="salvarParlamentar"
						>
							Salvar
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-container>
</template>

<script>
import VParlamentarForm from '@/forms/ParlamentarForm.vue';
import { Vue } from '@/main';

export default {
	components: { VParlamentarForm },
	data() {
		return {
			parlamentar: null,
			salvarLoading: false,
			removerLoading: false,
			validForm: null,
			dialog: false
		};
	},
	computed: {
		parlamentarForm() {
			let ComponentClass = Vue.extend(VParlamentarForm);
			let parlamentarForm = new ComponentClass();
			if (this.parlamentar && this.$refs && this.$refs.parlamentarForm) {
				return this.$refs.parlamentarForm;
			} else {
				return parlamentarForm;
			}
		}
	},
	async created() {
		if (this.$route.params.id !== 'novo') {
			this.parlamentar = await this.parlamentarForm.obterParlamentar(
				this.$route.params.id
			);
		}
	},
	methods: {
		async salvarParlamentar() {
			let parlamentarSalvo = await this.parlamentarForm.salvar();
			if (parlamentarSalvo && parlamentarSalvo.id) {
				this.$emit('snack', {
					show: true,
					text: `${parlamentarSalvo.nome} foi salvo com o ID ${parlamentarSalvo.id}`
				});
				this.$router.replace('/parlamentares');
			}
		},

		async confirmarRemocao() {
			let parlamentarRemovido = await this.parlamentarForm.remover();
			if (parlamentarRemovido && parlamentarRemovido.id) {
				this.$emit('snack', {
					show: true,
					text: `${parlamentarRemovido.nome} foi removido com o ID ${parlamentarRemovido.id}`
				});
				this.dialog = false;
				this.$router.replace('/parlamentares');
			}
			this.dialog = false;
		},

		cancelar() {
			this.$router.replace('/parlamentares');
		},

		cancelarRemocao() {
			this.dialog = false;
		}
	}
};
</script>
